import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Button, Input, Label} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import {createCategory, loadCategoryList, selectCategory} from 'manuals/actions/category';
import {searchManual} from 'manuals/actions/manual';

@connect(
    state => ({
        categoryList: state.manuals.categoryList
    }),
    dispatch => {
        return {
            loadCategoryList: () => dispatch(loadCategoryList()),
            selectCategory: (category) => dispatch(selectCategory(category)),
            createManualCategory: (category) => dispatch(createCategory(category)),
            searchManual: (searchText) => dispatch(searchManual(searchText))
        }
    }
)
export default class NewCategory extends Component {

    constructor() {
        super();
        this.state = {
            isOpen: false,
            newTemplateCategoryName: ''
        }
    }

    @autobind
    toggle() {
        this.setState({isOpen: !this.state.isOpen})
    }

    @autobind
    confirmNewManualCategory() {
        this.props.createManualCategory({name: this.state.newTemplateCategoryName})
        this.toggle()
    }

    @autobind
    setNewTemplateCategoryName(name) {
        this.setState({newTemplateCategoryName: name})
    }

    render() {
        return (
            <Fragment>
                <Button color='primary' onClick={this.toggle}>Neue Kategorie anlegen</Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    confirm={this.confirmNewManualCategory}
                    toggle={this.toggle}
                    title={'Neue Kategorie anlegen'}
                >
                    <Fragment>
                        <Label>
                            Name
                        </Label>
                        <Input
                            type="text"
                            value={this.state.newTemplateCategoryName}
                            onChange={e => this.setNewTemplateCategoryName(e.target.value)}/>
                    </Fragment>
                </Dialog>
            </Fragment>
        )
    }
}
